import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { CompanyService } from '../../../service/company/company.service';
import { Company } from '../../../class/company';
import { MapsAPILoader } from '@agm/core';
import { Marker } from '../../../../../interfaces/marker';
declare var google: any;

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss']
})
export class CompanyComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoCompany: Company;
    public company: Company;
    public msgs: Message[] = [];
    public options: any;
    public overlays: any[];
    public latitude: number;
    public longitude: number;
    public zoom: number;

    constructor(
        public companyService: CompanyService,
        private activatedRoute: ActivatedRoute,
        private mapsAPILoader: MapsAPILoader) {
    }

    ngOnInit() {
        if (this.infoCompany.latitude && this.infoCompany.longitude) {
            const lat = parseFloat(this.infoCompany.latitude);
            const lng = parseFloat(this.infoCompany.longitude);
            const position = {
                lat : lat,
                lng : lng
            };
            this.setPosition(position);
        }
    }

    private setPosition(position) {
        this.latitude = position.lat;
        this.longitude = position.lng;
        this.zoom = 17;
    }

    public addMarker(lat, lng, title) {
        this.longitude = lng;
        this.latitude = lat;
        this.overlays = [];
        this.overlays.push(
            new google.maps.Marker({
                position: {
                    lat: lat,
                    lng: lng
                }, title: title}
            )
        );
    }

    public cancelCompany () {
        this.close.emit(true);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/companies/company/company.component.ts